import { LocalizationService } from "../../localization/localization";

export class MultiSelectBinding {
  /** The text to display for the end user as clickable text to open the control .*/
  public menuText = "@";

  /** The list of menu items to bind to. It's expected that this list will conform to the SelectMenuItem class type. */
  public menuItems = "<";

  /** Callback raised when a menu item is selected. The callback argument is { item: MultiSelectItem }. */
  public menuItemSelected = "&?";

  /** Placeholder text to display when no items are selected. */
  public placeholderText = "@";

  /** Callback raised when the menu is opened or closed. The callback argument is { wasOpened: boolean }. */
  public onOpenChanged = "&?";

  /** The identifier for all business intelligence (BI) actions triggered by this component.*/
  public biId = "@?";
}
export interface MultiSelectItem {
  displayName: string;
  value: any;
  isSelected: boolean;
}

export class MultiSelectController {
  public menuItems: MultiSelectItem[];
  public menuItemSelected: (arg: { item: MultiSelectItem }) => void;
  public memoizedDescription: string;
  public separator: string;
  private onOpenChanged: (argument: { wasOpened: boolean }) => void;
  // @ngInject
  constructor(private $scope: ng.IScope, private sdLocalizationService: LocalizationService) {
    $scope.$watchCollection(
      () => {
        return this.menuItems;
      },
      () => {
        this.refreshDescription();
      }
    );
    this.separator = sdLocalizationService.getLocalizedString("ShellCommon", "_CONTROLS_MULTI_SELECT_SEPARATOR_");
  }

  public get formattedMenuItems(): string {
    if (!this.memoizedDescription) {
      this.refreshDescription();
    }

    return this.memoizedDescription;
  }

  public menuSelected(menuItem: MultiSelectItem, preventDefault: () => void) {
    menuItem.isSelected = !menuItem.isSelected;
    this.menuItemSelected({ item: menuItem });
    preventDefault();
    this.refreshDescription();
  }

  public selectMenuOpenedChanged(wasOpened: boolean) {
    if (this.onOpenChanged) {
      this.onOpenChanged({ wasOpened: wasOpened });
    }

    if (!wasOpened) {
      this.$scope.$emit("updateMultiSelectTelemetry");
    }
  }

  private refreshDescription(): void {
    if (!this.menuItems) {
      this.memoizedDescription = undefined;
      return;
    }

    let newDescription: string;
    for (let i = 0; i < this.menuItems.length; i++) {
      let item = this.menuItems[i];
      if (item.isSelected) {
        if (!newDescription) {
          newDescription = item.displayName;
        } else {
          newDescription += this.separator + item.displayName;
        }
      }
    }

    this.memoizedDescription = newDescription;
  }
}
export const sdMultiSelect: ng.IComponentOptions = {
  bindings: <any>new MultiSelectBinding(),
  controller: MultiSelectController,
  templateUrl: "../ShellCommon/Controls/multi-select/multi-select.html"
};
